import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.fixed.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import ReactDOM from 'react-dom';
import PropTypes from "prop-types";
import { debounce } from "throttle-debounce";
import { Event, EventUtil } from "./lib/utils";
import FilterType from "./FilterType";
import { prefix } from "../../wui-core/src/index.js";
var propTypes = {
  clsPrefix: PropTypes.string,
  rowStyle: PropTypes.object,
  rows: PropTypes.array
};

var TableHeader = /*#__PURE__*/function (_Component) {
  _inherits(TableHeader, _Component);

  var _super = _createSuper(TableHeader);

  function TableHeader(props) {
    var _this;

    _classCallCheck(this, TableHeader);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "createTableNone", function () {
      _this._table_none_cont_id = _this.props.tableUid || "_table_uid_" + new Date().getTime();
      if (document.getElementById(_this._table_none_cont_id)) return;
      var div = document.createElement("div");
      div.className = "".concat(prefix, "-table-drag-hidden-cont");
      div.id = _this._table_none_cont_id;
      document.body.appendChild(div);
      return div;
    });

    _defineProperty(_assertThisInitialized(_this), "destroyTableNone", function () {
      var elem = document.getElementById(_this._table_none_cont_id);
      if (!elem) return;

      if (elem.remove) {
        elem.remove();
      } else {
        //ie 不支持remove方法，只能用removeChild方法
        elem.parentNode.removeChild(elem);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getOnLineObject", function (_element) {
      var type = _element.getAttribute('data-type'),
          elementObj = null;

      if (!type) {
        var element = _element.parentElement || parentNode; //兼容写法。

        if (element.getAttribute('data-type')) {
          elementObj = element;
        }
      } else {
        elementObj = _element;
      }

      return elementObj;
    });

    _defineProperty(_assertThisInitialized(_this), "onDragMouseDown", function (e) {
      var _this$props = _this.props,
          dragborder = _this$props.dragborder,
          eventNoStop = _this$props.eventNoStop,
          onMouseDown = _this$props.onMouseDown;
      !eventNoStop && Event.stopPropagation(e);
      dragborder && typeof onMouseDown == 'function' && onMouseDown(e);
    });

    _defineProperty(_assertThisInitialized(_this), "getTableWidth", function () {
      var tableWidth = 0,
          offWidth = 0; //this.table.cols.length;

      for (var index = 0; index < _this.table.cols.length; index++) {
        var da = _this.table.cols[index];
        tableWidth += parseInt(da.style.width);
      }

      return tableWidth - offWidth;
    });

    _defineProperty(_assertThisInitialized(_this), "getTargetToType", function (targetEvent) {
      var tag = targetEvent;

      if (targetEvent && !targetEvent.getAttribute("data-type")) {
        tag = _this.getTargetToType(targetEvent.parentElement);
      }

      return tag;
    });

    _defineProperty(_assertThisInitialized(_this), "getTargetToTh", function (targetEvent) {
      var th = targetEvent;

      if (targetEvent.nodeName.toUpperCase() != "TH") {
        th = _this.getThDome(targetEvent);
      } // console.log(" getTargetToTh: ", th);


      return th;
    });

    _defineProperty(_assertThisInitialized(_this), "onTrMouseMove", function (e) {
      // console.log("AAA---TableHeader---mousemove->",e);
      if (!_this.props.dragborder && !_this.props.draggable) return;
      var _this$props2 = _this.props,
          clsPrefix = _this$props2.clsPrefix,
          dragborder = _this$props2.dragborder,
          contentDomWidth = _this$props2.contentDomWidth,
          scrollbarWidth = _this$props2.scrollbarWidth,
          contentTable = _this$props2.contentTable,
          headerScroll = _this$props2.headerScroll,
          lastShowIndex = _this$props2.lastShowIndex,
          onMouseMove = _this$props2.onMouseMove,
          onDraggingBorder = _this$props2.onDraggingBorder,
          leftFixedWidth = _this$props2.leftFixedWidth,
          rightFixedWidth = _this$props2.rightFixedWidth,
          bodyDisplayInRow = _this$props2.bodyDisplayInRow,
          eventNoStop = _this$props2.eventNoStop;
      !eventNoStop && Event.stopPropagation(e);
      var event = Event.getEvent(e);

      if (_this.props.dragborder && _this.drag.option == "border") {
        //移动改变宽度
        var isMoveToRight = _this.drag.currentLeft < event.clientX;

        if (_this.drag.fixedType === 'left' && isMoveToRight && _this.drag.fixedRightBodyTableLeft) {
          if (_this.drag.fixedRightBodyTableLeft - event.clientX < 100) {
            return; // 拖动左侧固定列，离右侧固定列距离小于100时，禁止拖动
          }
        }

        var currentCols = _this.table.cols[_this.drag.currIndex];
        var diff = event.clientX - _this.drag.oldLeft;
        var newWidth = _this.drag.oldWidth + diff;
        _this.drag.newWidth = newWidth > 0 ? newWidth : _this.minWidth;
        _this.drag.currentLeft = event.clientX; // displayinrow 判断、 固定行高判断

        if (!bodyDisplayInRow) {
          _this.table.bodyRows.forEach(function (row, index) {
            var leftRow = _this.table.fixedLeftBodyRows[index];
            var rightRow = _this.table.fixedRightBodyRows[index];

            if (leftRow || rightRow) {
              var height = row.getBoundingClientRect().height;
              leftRow && (leftRow.style.height = height + "px");
              rightRow && (rightRow.style.height = height + "px");
            }
          });
        }

        if (newWidth > _this.minWidth) {
          //移动后的宽度大于列最小宽度，则更新列和内容宽度

          /*拖拽列宽度使用尺标代替不再实时更新重绘宽度
          currentCols.style.width = newWidth +'px'; //中间表头-拖拽过程中实时更新重绘宽度
          //hao 支持固定表头拖拽 修改表体的width
          if(this.fixedTable.cols){
              this.fixedTable.cols[this.drag.currIndex].style.width = newWidth + "px";//固定列表头-拖拽过程中实时更新重绘宽度
          }
           const  contentTableSWidth = this.drag.contentTableSWidth - this.drag.contentTableCWidth;
            // console.log('contentTableSWidth+diff',contentTableSWidth+diff,'diff',diff);
            if(diff<0 && contentTableSWidth+diff < 0) {//拖拽后宽度小于可视宽度，则最后一列自动缩减宽度
              const headerCols = this.table.tableHeaderCols || this.table.cols;
              const lastWidth =this.lastColumWidth - (contentTableSWidth+diff);
              headerCols[headerCols.length-1].style.width = lastWidth +"px";//同步表头
              this.table.tableBodyCols[headerCols.length-1].style.width = lastWidth + "px";//同步表体
            }
           */
          // 内容区非固定列场景拖拽
          if (!_this.drag.fixedType) {// let newDiff = (parseInt(currentCols.style.minWidth) - parseInt(currentCols.style.width));
            // if(newDiff > 0){//缩小
            //   let lastWidth = this.lastColumWidth + newDiff;
            //   this.table.cols[lastShowIndex].style.width = lastWidth +"px";//同步表头
            //   this.table.tableBodyCols[lastShowIndex].style.width = lastWidth + "px";//同步表体
            // }
            // let dargTableWidth = parseFloat(window.getComputedStyle(this.table.table).width)
            // let showScroll =  contentDomWidth - (leftFixedWidth + rightFixedWidth) - (dargTableWidth + diff) - scrollbarWidth;
            // //let showScroll =  contentDomWidth - (leftFixedWidth + rightFixedWidth) - (this.drag.tableWidth + diff) - scrollbarWidth ;
            //
            //  //表头滚动条处理
            //  if(headerScroll){
            //    if(showScroll < 0){ //小于 0 出现滚动条
            //        //找到固定列表格，设置表头的marginBottom值为scrollbarWidth;
            //        this.table.contentTableHeader.style.overflowX = 'scroll';
            //        this.optTableMargin( this.table.fixedLeftHeaderTable,scrollbarWidth);
            //        this.optTableMargin( this.table.fixedRightHeaderTable,scrollbarWidth);
            //      }else{ //大于 0 不显示滚动条
            //        this.table.contentTableHeader.style.overflowX = 'hidden';
            //        this.optTableMargin( this.table.fixedLeftHeaderTable,0);
            //        this.optTableMargin( this.table.fixedRightHeaderTable,0);
            //    }
            //  }else{
            //  // const scrollContainers = this.table.tableBody.querySelectorAll('.scroll-container') || []
            //  if(showScroll < 0){
            //    // scrollContainers[0] ? scrollContainers[0].style.overflowX = 'auto' : null//暂时注释，还原原来逻辑
            //        this.table.tableBody.style.overflowX = 'auto';
            //        this.optTableMargin( this.table.fixedLeftBodyTable,'-'+scrollbarWidth);
            //        this.optTableMargin( this.table.fixedRightBodyTable,'-'+scrollbarWidth);
            //        this.optTableScroll( this.table.fixedLeftBodyTable,{x:'scroll'});
            //        this.optTableScroll( this.table.fixedRightBodyTable,{x:'scroll'});
            //  }else{
            //    // scrollContainers[0] ? scrollContainers[0].style.overflowX = 'hidden' : null
            //    this.table.tableBody.style.overflowX = 'hidden';//暂时注释，还原原来逻辑
            //    this.optTableMargin( this.table.fixedLeftBodyTable,0);
            //    this.optTableMargin( this.table.fixedRightBodyTable,0);
            //    this.optTableScroll( this.table.fixedLeftBodyTable,{x:'auto'});
            //    this.optTableScroll( this.table.fixedRightBodyTable,{x:'auto'});
            //  }
            //  }
          } else if (_this.drag.fixedType) {
            if (_this.table.ths[_this.drag.currIndex]) {
              _this.table.ths[_this.drag.currIndex].width = newWidth;
            } // console.log('this.drag.contentTableML',this.drag.contentTableML,'diff',diff);
            // debugger
            // this.syncFixedBodyTableWidth() // 同步body中table的宽度 以移到Table.syncFixedBodyTableWidth


            var contentTablePar = _this.table.contentTableHeader.parentNode; // left、right缩小的内容，在没有滚动条时，需要将宽度同步到到最后一列
            // diff<0 往里拖，
            // const  contentTableSWidth = this.drag.contentTableSWidth - this.drag.contentTableCWidth;
            // console.log('contentTableSWidth+diff',contentTableSWidth+diff,'diff',diff);
            // if(diff<0 && contentTableSWidth+diff < 0) {
            //   const headerCols = this.table.tableHeaderCols || this.table.cols;
            //   const lastWidth =this.lastColumWidth - (contentTableSWidth+diff);
            //   console.log('lastWidth',lastWidth,'lastShowIndex',lastShowIndex);
            //   headerCols[lastShowIndex].style.width = lastWidth +"px";//同步表头
            //   this.table.tableBodyCols[lastShowIndex].style.width = lastWidth + "px";//同步表体
            // }

            if (_this.drag.fixedType == 'left') {
              contentTablePar.style.marginLeft = _this.drag.contentTableML + diff + 'px';
            } else {
              contentTablePar.style.marginRight = _this.drag.contentTableMR + diff + 'px';
            } //暂时注释，还原
            // const containerWidth = contentTablePar.getBoundingClientRect().width
            // const tableWidth = this.table.innerTableBody.getBoundingClientRect().width
            // const scrollContainers = this.table.tableBody.querySelectorAll('.scroll-container') || []
            // if (tableWidth > containerWidth) {
            //   scrollContainers[0] ? scrollContainers[0].style.overflowX = 'auto' : null
            //   this.optTableMargin( this.table.fixedLeftBodyTable,'-'+scrollbarWidth);
            //   this.optTableMargin( this.table.fixedRightBodyTable,'-'+scrollbarWidth);
            //   this.optTableScroll( this.table.fixedLeftBodyTable,{x:'scroll'});
            //   this.optTableScroll( this.table.fixedRightBodyTable,{x:'scroll'});
            // } else {
            //   scrollContainers[0] ? scrollContainers[0].style.overflowX = 'hidden' : null
            //   this.optTableMargin( this.table.fixedLeftBodyTable,0);
            //   this.optTableMargin( this.table.fixedRightBodyTable,0);
            //   this.optTableScroll( this.table.fixedLeftBodyTable,{x:'auto'});
            //   this.optTableScroll( this.table.fixedRightBodyTable,{x:'auto'});
            // }

          }
        } else {
          _this.drag.newWidth = _this.minWidth;
        }
      } // console.log("AAAA----TableHeader---newWidth-->"+this.drag.newWidth)
      // onMouseMove && onMouseMove(e);
      // 增加拖拽列宽动作的回调函数


      _this.drag.newWidth && onDraggingBorder && onDraggingBorder(event, _this.drag.newWidth);
    });

    _defineProperty(_assertThisInitialized(_this), "syncFixedBodyTableWidth", function () {
      var _this$table = _this.table,
          fixedLeftHeaderTableBody = _this$table.fixedLeftHeaderTableBody,
          fixedLeftInnerTableBody = _this$table.fixedLeftInnerTableBody,
          fixedRightHeaderTableBody = _this$table.fixedRightHeaderTableBody,
          fixedRightInnerTableBody = _this$table.fixedRightInnerTableBody;

      if (fixedLeftHeaderTableBody && fixedLeftInnerTableBody) {
        fixedLeftInnerTableBody.style.width = fixedLeftHeaderTableBody.getBoundingClientRect().width + 'px';
      }

      if (fixedRightHeaderTableBody && fixedRightInnerTableBody) {
        fixedRightInnerTableBody.style.width = fixedRightHeaderTableBody.getBoundingClientRect().width + 'px';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onTrMouseUp", function (e) {
      var event = Event.getEvent(e);
      var width = _this.drag.newWidth;
      var opt = _this.drag.option;

      _this.mouseClear();

      if (opt !== "border") return; // fix:点击表头会触发onDropBorder事件的问题

      _this.props.onDropBorder && _this.props.onDropBorder(event, width);
    });

    _defineProperty(_assertThisInitialized(_this), "clearThsDr", function () {
      var ths = _this.table.ths;

      for (var index = 0; index < ths.length; index++) {
        ths[index].setAttribute('draggable', false); //去掉交换列效果
      }
    });

    _defineProperty(_assertThisInitialized(_this), "bodyonLineMouseUp", function (events, type) {
      if (!_this.drag || !_this.drag.option) return;

      _this.mouseClear();
    });

    _defineProperty(_assertThisInitialized(_this), "dragAbleMouseDown", function (e) {
      var eventNoStop = _this.props.eventNoStop;
      !eventNoStop && Event.stopPropagation(e);
      var event = Event.getEvent(e),
          targetEvent = Event.getTarget(event);
      if (!_this.props.draggable) return;

      var currentElement = _this.getTargetToType(targetEvent);

      if (!currentElement) return;
      var type = currentElement.getAttribute('data-type');

      if (type == 'draggable' && _this.props.draggable) {
        var th = currentElement;
        th.setAttribute('draggable', true); //添加交换列效果

        _this.drag.option = 'dragAble';
        _this.currentDome = th;
        _this.drag.dragTarget = th; //抓起的th目标
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragStart", function (e) {
      if (!_this.props.draggable) return;

      if (_this.drag && _this.drag.option != 'dragAble') {
        return;
      }

      var event = Event.getEvent(e);
      var target = _this.drag.dragTarget; //抓起的th目标

      var currColKey = target.getAttribute("data-col-key");
      var currColIndex = target.getAttribute('data-col-index');

      if (event.dataTransfer.setDragImage) {
        var crt = target.cloneNode(true);
        crt.style.backgroundColor = "#ebecf0";
        crt.style.width = _this.table.cols[currColIndex].style.width; //拖动后再交换列的时候，阴影效果可同步

        crt.style.height = "40px";
        document.getElementById(_this._table_none_cont_id).appendChild(crt);
        event.dataTransfer.setDragImage(crt, 0, 0);
      }

      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("Text", currColKey);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragOver", function (e) {
      var event = Event.getEvent(e);
      event.preventDefault();
    });

    _defineProperty(_assertThisInitialized(_this), "onDrop", function (e) {
      if (!_this.props.draggable) return;

      if (_this.drag && _this.drag.option != 'dragAble') {
        _this.props.onDrop && _this.props.onDrop(e);
        return;
      }

      var event = Event.getEvent(e);
      Event.preventDefault(e); //防止拖拽后打开a链接

      Event.stopPropagation(e);

      _this.currentDome.setAttribute('draggable', false); //添加交换列效果


      if (!_this.props.onDrop) return;
      var _this$drag = _this.drag,
          dragTarget = _this$drag.dragTarget,
          enterTarget = _this$drag.enterTarget;
      var dragColKey = dragTarget && dragTarget.getAttribute("data-col-key"); //抓起的th目标

      var dropColKey = enterTarget && enterTarget.getAttribute("data-col-key");

      var dragSourceColumn = _this.props.rows[0].find(function (da) {
        return da.key == dragColKey;
      }); //抓取来源列定义


      var dragTargetColumn = _this.props.rows[0].find(function (da) {
        return da.key == dropColKey;
      }); //放置目标列定义


      if (dragSourceColumn.fixed !== dragTargetColumn.fixed) return; //固定列和非固定列之间不能拖拽换顺序

      _this.props.onDrop(event, {
        dragSource: dragSourceColumn,
        dragTarget: dragTargetColumn
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function (e) {
      var event = Event.getEvent(e),
          target = Event.getTarget(event);
      _this.drag.enterTarget = target; //拖拽进入的目标th

      var dragColKey = _this.drag.dragTarget && _this.drag.dragTarget.getAttribute('data-col-key');

      var dragColFixed = _this.drag.dragTarget && _this.drag.dragTarget.getAttribute('data-th-fixed');

      var currColKey = target.getAttribute("data-col-key");
      var currColFixed = target.getAttribute("data-th-fixed");
      if (dragColFixed !== currColFixed) return; //固定列和非固定列之间不能拖拽换顺序

      if (!currColKey || currColKey === dragColKey) return; //拖放在同一个th目标上时则结束

      if (target.nodeName.toUpperCase() === "TH") {
        // 显示交换的插入点
        target.setAttribute("style", "border-right:2px dashed rgb(30, 136, 229)");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnd", function (e) {
      var event = Event.getEvent(e),
          target = Event.getTarget(event);
      var _this$drag2 = _this.drag,
          enterTarget = _this$drag2.enterTarget,
          dragTarget = _this$drag2.dragTarget;
      enterTarget && enterTarget.setAttribute("style", ""); //清除进入目标th的插入点

      event.preventDefault();
      event.stopPropagation(); //清除抓取目标的副本

      document.getElementById(_this._table_none_cont_id).innerHTML = "";
      if (!_this.props.onDragEnd) return;
      var dragColKey = dragTarget && dragTarget.getAttribute('data-col-key');
      var dropColKey = enterTarget && enterTarget.getAttribute("data-col-key");

      var dragSourceColumn = _this.props.rows[0].find(function (da) {
        return da.key == dragColKey;
      }); //抓取来源列定义


      var dragTargetColumn = _this.props.rows[0].find(function (da) {
        return da.key == dropColKey;
      }); //放置目标列定义


      if (!dragTargetColumn) return;
      if (dragSourceColumn.fixed !== dragTargetColumn.fixed) return; //固定列和非固定列之间不能拖拽换顺序

      if (!dropColKey || dropColKey == dragColKey) return;

      _this.props.onDragEnd(event, {
        dragSource: dragSourceColumn,
        dragTarget: dragTargetColumn
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function (e) {
      var event = Event.getEvent(e),
          target = Event.getTarget(event);

      var dragColKey = _this.drag.dragTarget && _this.drag.dragTarget.getAttribute('data-col-key');

      var currColKey = target.getAttribute("data-col-key");
      if (!currColKey || currColKey === dragColKey) return;

      if (target.nodeName.toUpperCase() === "TH") {
        // 清除交换的插入点
        target.setAttribute("style", "");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlerFilterChange", function (key, value, condition) {
      var onFilterChange = _this.props.onFilterChange;

      if (onFilterChange) {
        onFilterChange(key, value, condition);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlerFilterClear", function (field) {
      var onFilterClear = _this.props.onFilterClear;

      if (onFilterClear) {
        onFilterClear(field);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "filterRenderType", function (type, dataIndex, index) {
      var _this$props3 = _this.props,
          clsPrefix = _this$props3.clsPrefix,
          rows = _this$props3.rows,
          filterDelay = _this$props3.filterDelay,
          locale = _this$props3.locale;

      switch (type) {
        //文本输入
        case "text":
          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale //多语
            ,
            rendertype: type //渲染类型
            ,
            clsPrefix: clsPrefix //css前缀
            ,
            className: "".concat(clsPrefix, " filter-text"),
            dataIndex: dataIndex //字段
            ,
            onFilterChange: debounce(filterDelay || 300, _this.handlerFilterChange) //输入框回调
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"] //是否显示下拉条件
            ,
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示

          });
        //数值输入

        case "number":
          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale,
            rendertype: type,
            clsPrefix: clsPrefix,
            className: "".concat(clsPrefix, " filter-text"),
            dataIndex: dataIndex //字段
            ,
            onFilterChange: debounce(filterDelay || 300, _this.handlerFilterChange) //输入框回调并且函数防抖动
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"],
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示
            ,
            filterInputNumberOptions: rows[1][index]["filterinputnumberoptions"] //设置数值框内的详细属性

          });
        //下拉框选择

        case "dropdown":
          var selectDataSource = []; //处理没有输入数据源的时候，系统自动查找自带的数据筛选后注入

          if (rows.length > 0 && (rows[1][index]["filterdropdownauto"] || "auto") == "auto") {
            var hash = {}; //处理下拉重复对象组装dropdown

            selectDataSource = Array.from(rows[1][0].datasource, function (x) {
              return {
                key: x[dataIndex],
                value: x[dataIndex]
              };
            });
            selectDataSource = selectDataSource.reduceRight(function (item, next) {
              hash[next.key] ? "" : hash[next.key] = true && item.push(next);
              return item;
            }, []);
          } else {
            //从外部数据源加载系统数据
            selectDataSource = rows[1][index]["filterdropdowndata"];
          }

          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale,
            rendertype: type,
            className: "".concat(clsPrefix, " filter-dropdown"),
            data: selectDataSource,
            notFoundContent: "Loading" //没有数据显示的默认字
            ,
            dataIndex: dataIndex //字段
            ,
            onFilterChange: _this.handlerFilterChange //输入框回调
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"],
            onFocus: rows[1][index]["filterdropdownfocus"],
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示

          });
        //日期

        case "date":
          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale,
            rendertype: type,
            className: "filter-date",
            onClick: function onClick() {},
            format: rows[1][index]["format"] || "YYYY-MM-DD",
            dataIndex: dataIndex //字段
            ,
            onFilterChange: _this.handlerFilterChange //输入框回调
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"],
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示

          });
        //日期 年

        case "dateyear":
          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale,
            rendertype: type,
            className: "filter-date",
            onClick: function onClick() {},
            format: rows[1][index]["format"] || "YYYY",
            dataIndex: dataIndex //字段
            ,
            onFilterChange: _this.handlerFilterChange //输入框回调
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"],
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示

          });
        //日期 月

        case "datemonth":
          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale,
            rendertype: type,
            className: "filter-date",
            onClick: function onClick() {},
            format: rows[1][index]["format"] || "YYYY-MM",
            dataIndex: dataIndex //字段
            ,
            onFilterChange: _this.handlerFilterChange //输入框回调
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"],
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示

          });
        //日期 周

        case "dateweek":
          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale,
            rendertype: type,
            className: "filter-date",
            onClick: function onClick() {},
            format: rows[1][index]["format"] || "YYYY-Wo",
            dataIndex: dataIndex //字段
            ,
            onFilterChange: _this.handlerFilterChange //输入框回调
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"],
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示

          });
        //日期范围

        case "daterange":
          return /*#__PURE__*/React.createElement(FilterType, {
            locale: locale,
            rendertype: type,
            className: "filter-date",
            onClick: function onClick() {},
            format: rows[1][index]["format"] || "YYYY-MM-DD",
            dataIndex: dataIndex //字段
            ,
            onFilterChange: _this.handlerFilterChange //输入框回调
            ,
            onFilterClear: _this.handlerFilterClear //清除回调
            ,
            filterDropdown: rows[1][index]["filterdropdown"],
            filterDropdownType: rows[1][index]["filterdropdowntype"] //下拉的条件类型为string,number
            ,
            filterDropdownIncludeKeys: rows[1][index]["filterdropdownincludekeys"] //下拉条件按照指定的keys去显示

          });

        default:
          //不匹配类型默认文本输入
          return /*#__PURE__*/React.createElement("div", null);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCopy", function (data, index, event) {
      if (_this.props.onCopy) {
        _this.props.onCopy(Object.assign(data, {
          col: index
        }), event);
      }
    });

    _this.currentObj = null;
    _this.theadKey = new Date().getTime();
    _this.drag = {
      option: '' //拖拽的操作类型

    };
    _this.minWidth = parseInt(props.minColumnWidth);
    _this.table = null;
    _this._thead = null; //当前对象

    _this.event = false; //避免多次绑定问题

    _this.lastColumWidth = null; //非固定列最后一列的初始化宽度

    _this.fixedTable = {};
    _this.isIE = !!window.ActiveXObject || "ActiveXObject" in window;
    return _this;
  }

  _createClass(TableHeader, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // 表格column改变时，要重新绑定拖拽事件，否则拖拽不生效
      var oldCols = this.props.columnsChildrenList;
      var newCols = nextProps.columnsChildrenList;

      if (this._thead) {
        if (newCols.length !== oldCols.length) {
          this.event = false;
          return;
        }

        oldCols.some(function (item, index) {
          if (newCols[index] && newCols[index].dataIndex !== item.dataIndex) {
            _this2.event = false;
            return true;
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.initTable();
      this.initEvent();
    } //----交换列头顺序时抓起的副本---begin

  }, {
    key: "componentDidMount",
    value: //----交换列头顺序时抓起的副本---end
    function componentDidMount() {
      this.createTableNone(); // 交换列头时用到的副本-创建
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyTableNone(); // 交换列头时用到的副本-销毁

      this.fixedTable = null;
      if (!this.table) return;

      if (this.props.draggable) {
        this.removeDragAbleEvent();
      }

      if (this.props.dragborder) {
        this.removeDragBorderEvent();
      }
      /*removeDragBorderEvent方法里面已经处理过了，重复逻辑去掉 by zhuzj
      this.doEventList(this.table.tr,(tr)=>{
        this.eventListen([{key:'mousedown',fun:this.onTrMouseDown}],'remove',tr);
      })
      */
      // this.eventListen([{key:'mousedown',fun:this.onTrMouseDown}],'remove',this.table.tr[0]);


      this.eventListen([{
        key: 'mouseup',
        fun: this.bodyonLineMouseUp
      }], 'remove', document.body);
    }
    /**
     * 获取table的属性存放在this.table 中。(公用方法)
     * @returns
     * @memberof TableHeader
     */

  }, {
    key: "initTable",
    value: function initTable() {
      var _this$props4 = this.props,
          clsPrefix = _this$props4.clsPrefix,
          contentTable = _this$props4.contentTable;
      if (!this.props.dragborder && !this.props.draggable) return;
      var tableDome = this._thead.parentNode;
      var table = {};

      if (tableDome && tableDome.nodeName && tableDome.nodeName.toUpperCase() == "TABLE") {
        table.table = tableDome;
        table.cols = tableDome.getElementsByTagName("col");
        table.ths = tableDome.getElementsByTagName("th");
        table.tr = tableDome.getElementsByTagName("tr");
        table.thDragGaps = tableDome.getElementsByClassName("".concat(clsPrefix, "-thead-th-drag-gap")) || []; //拖拽列宽的全部抓手

        table.tableHeaderCols = contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-header")) && contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-header")).getElementsByTagName("col");
        table.tableBody = contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-body")) && contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-body"));
        table.tableBodyCols = contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-body")) && contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-body")).getElementsByTagName("col");
        table.bodyRows = table.tableBody && table.tableBody.querySelectorAll('tr') || [];
        table.fixedLeftHeaderTable = contentTable.querySelector(".".concat(prefix, "-table-fixed-left .").concat(prefix, "-table-header"));
        table.fixedRightHeaderTable = contentTable.querySelector(".".concat(prefix, "-table-fixed-right .").concat(prefix, "-table-header"));
        table.contentTableHeader = contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-header"));
        table.fixedLeftBodyTable = contentTable.querySelectorAll(".".concat(prefix, "-table-fixed-left .").concat(prefix, "-table-body-outer"));

        if (table.fixedLeftBodyTable) {
          var leftBodyTableIndex = table.fixedLeftBodyTable.length - 1 < 0 ? 0 : table.fixedLeftBodyTable.length - 1;
          table.fixedLeftBodyTable = table.fixedLeftBodyTable[leftBodyTableIndex];
        }

        table.fixedRightBodyTable = contentTable.querySelectorAll(".".concat(prefix, "-table-fixed-right .").concat(prefix, "-table-body-outer"));

        if (table.fixedRightBodyTable) {
          var rightBodyTableIndex = table.fixedRightBodyTable.length - 1 < 0 ? 0 : table.fixedRightBodyTable.length - 1;
          table.fixedRightBodyTable = table.fixedRightBodyTable[rightBodyTableIndex];
        }

        table.innerTableBody = contentTable.querySelector(".".concat(prefix, "-table-scroll .").concat(prefix, "-table-body table"));
        table.fixedLeftHeaderTableBody = table.fixedLeftHeaderTable && table.fixedLeftHeaderTable.querySelector('table') || null;
        table.fixedRightHeaderTableBody = table.fixedRightHeaderTable && table.fixedRightHeaderTable.querySelector('table') || null;
        table.fixedLeftInnerTableBody = table.fixedLeftBodyTable && table.fixedLeftBodyTable.querySelector('table') || null;
        table.fixedRightInnerTableBody = table.fixedRightBodyTable && table.fixedRightBodyTable.querySelector('table') || null;
        table.fixedLeftBodyRows = table.fixedLeftBodyTable && table.fixedLeftBodyTable.querySelectorAll('tr') || [];
        table.fixedRightBodyRows = table.fixedRightBodyTable && table.fixedRightBodyTable.querySelectorAll('tr') || [];
      } //维护表格全部的dom元素


      this.table = table;
      /*
      if(!this.props.dragborder)return;
      if(document.getElementById("u-table-drag-thead-" + this.theadKey)){
        this.fixedTable = {};
        let _fixedParentContext =  document.getElementById("u-table-drag-thead-" + this.theadKey).parentNode;
        let siblingDom = _fixedParentContext.parentNode.nextElementSibling;
        if (siblingDom) {
          let fixedTable = siblingDom.querySelector("table");
          // this.fixedTable.table = fixedTable //没有用到
          this.fixedTable.cols = fixedTable&&fixedTable.getElementsByTagName("col");
          // this.fixedTable.ths = fixedTable.tableDome.getElementsByTagName("th");
        }
      }
      */
    }
    /**
     * 事件初始化
     */

  }, {
    key: "initEvent",
    value: function initEvent() {
      var _this$props5 = this.props,
          dragborder = _this$props5.dragborder,
          draggable = _this$props5.draggable,
          rows = _this$props5.rows; // 当传入的 columns 为空时，不绑定拖拽事件

      if (Object.prototype.toString.call(rows) === '[object Array]' && rows.length === 0) {
        return;
      }

      if (!this.event) {
        //避免多次绑定问题。
        this.event = true;

        if (dragborder) {
          this.dragBorderEventInit(); //列宽
        }

        if (draggable) {
          this.dragAbleEventInit(); //交换列
        }
        /* dragBorderEventInit、dragAbleEventInit方法里面已经处理过了，重复逻辑去除 by zhuzj
        if(this.table && this.table.tr){
          // this.eventListen([{key:'mousedown',fun:this.onTrMouseDown}],'',this.table.tr[0]);//body mouseup
          this.doEventList(this.table.tr,(tr)=>{
            this.eventListen([{key:'mousedown',fun:this.onTrMouseDown}],'',tr);//body mouseup
          })
        }
        */


        this.eventListen([{
          key: 'mouseup',
          fun: this.bodyonLineMouseUp
        }], '', document.body); //body mouseup
      }
    }
  }, {
    key: "doEventList",
    value: function doEventList(trs, action) {
      if (trs && HTMLCollection.prototype.isPrototypeOf(trs) && action) {
        if (this.isIE && !trs[0]) return;

        for (var index = 0; index < trs.length; index++) {
          action(trs[index]);
        }
      }
    }
    /**
     * 拖拽列宽事件的监听
     */

  }, {
    key: "dragBorderEventInit",
    value: function dragBorderEventInit() {
      var _this3 = this;

      if (!this.props.dragborder) return;
      /* 事件监听不应该渲染到body上性能损耗很大 by zhuzj
      this.eventListen([{key:'mouseup', fun:this.onTrMouseUp}],'',document.body);
      this.eventListen([{key:'mousemove', fun:this.onTrMouseMove}],'',document.body);
      */

      var events = [// {key:'mousedown', fun:this.onTrMouseDown},
      {
        key: 'mousedown',
        fun: this.onDragMouseDown
      }, //拖拽列宽度-尺标方式
      {
        key: 'mouseup',
        fun: this.onTrMouseUp
      } // {key:'mousemove', fun:this.onTrMouseMove},
      ];
      this.doEventList(this.table.thDragGaps, function (elem) {
        _this3.eventListen(events, '', elem); //表示把事件添加到元素上

      });
    }
    /**
     * 删除拖动改变列宽的事件监听
     */

  }, {
    key: "removeDragBorderEvent",
    value: function removeDragBorderEvent() {
      var _this4 = this;

      var events = [// {key:'mousedown', fun:this.onTrMouseDown},
      {
        key: 'mousedown',
        fun: this.onDragMouseDown
      }, //拖拽列宽度-尺标方式
      {
        key: 'mouseup',
        fun: this.onTrMouseUp
      } // {key:'mousemove', fun:this.onTrMouseMove},
      ];
      this.doEventList(this.table.thDragGaps, function (elem) {
        _this4.eventListen(events, 'remove', elem); //表示把事件添加到元素上

      });
    } // 将多个事件绑定到dom元素上

  }, {
    key: "eventListen",
    value: function eventListen(events, type, eventSource) {
      if (!this.table) return;

      if (!eventSource) {
        console.log("Please set the attributes of column !");
        return;
      }

      for (var i = 0; i < events.length; i++) {
        var _event = events[i];

        if (type === "remove") {
          EventUtil.removeHandler(eventSource, _event.key, _event.fun);
        } else {
          EventUtil.addHandler(eventSource, _event.key, _event.fun);
        }
      }
    }
    /**
     *
     *根据 data-type 来获取当前拖拽的对象的Object，如果为null表示拖动的对象并非是online
     * @memberof TableHeader
     */

  }, {
    key: "mouseClear",
    value: function mouseClear() {
      if (!this.drag || !this.drag.option) return;
      var rows = this.props.rows;
      var data = {
        rows: rows[0],
        cols: this.table.cols,
        currIndex: this.drag.currIndex
      };
      this.props.afterDragColWidth && this.props.afterDragColWidth(data);
      this.drag = {
        option: ""
      };
      this.clearThsDr();
    }
  }, {
    key: "dragAbleEventInit",
    value:
    /**
     *相关滚动条联动操作
     *
     * @memberof TableHeader
     */

    /*
    optTableMargin =(table,scrollbarWidth)=>{
      if(table){
        table.style.marginBottom = scrollbarWidth + "px"
      }
    }
     optTableScroll = (table,overflow ={})=>{
      if(table){
        const innerTable = table.querySelector('.u-table-body-inner');
        if(innerTable){
          //fixbug: 拖拽列宽后，滚动条滚到表格底部，会导致固定列和非固定列错行，//暂时注释，还原
          // if (overflow.x) {
          //   const fixedScrollContainers = innerTable.querySelectorAll('.fixed-scroll-container')
          //   if (fixedScrollContainers && fixedScrollContainers.length) {
          //     fixedScrollContainers[0] && (fixedScrollContainers[0].style.overflowX = overflow.x);
          //     fixedScrollContainers[1] && (fixedScrollContainers[1].style.overflowX = overflow.x);
          //   }
          // }
          overflow.y && (innerTable.style.overflowY = overflow.y);
          // overflow.x && (innerTable.style.overflowX = overflow.x);
        }
       }
    }
    */
    //---拖拽交换列代码----start-----

    /**
     * 添加换列的事件监听
     */
    function dragAbleEventInit() {
      if (!this.props.draggable) return;
      var events = [{
        key: 'mousedown',
        fun: this.dragAbleMouseDown
      }, //用户开始按住列头元素时触发
      {
        key: 'dragstart',
        fun: this.onDragStart
      }, //用户开始拖动元素时触发
      {
        key: 'dragover',
        fun: this.onDragOver
      }, //当某被拖动的对象在另一对象容器范围内拖动时触发此事件
      {
        key: 'drop',
        fun: this.onDrop
      }, //在一个拖动过程中，释放鼠标键时触发此事件
      {
        key: 'dragenter',
        fun: this.onDragEnter
      }, {
        key: 'dragend',
        fun: this.onDragEnd
      }, {
        key: 'dragleave',
        fun: this.onDragLeave
      }];
      this.eventListen(events, '', this.table.tr[0]); //表示把事件添加到th元素上
    }
    /**
     * 删除换列的事件监听
     */

  }, {
    key: "removeDragAbleEvent",
    value: function removeDragAbleEvent() {
      var events = [{
        key: 'mousedown',
        fun: this.dragAbleMouseDown
      }, {
        key: 'dragstart',
        fun: this.onDragStart
      }, {
        key: 'dragover',
        fun: this.onDragOver
      }, {
        key: 'drop',
        fun: this.onDrop
      }, {
        key: 'dragenter',
        fun: this.onDragEnter
      }, {
        key: 'dragend',
        fun: this.onDragEnd
      }, {
        key: 'dragleave',
        fun: this.onDragLeave
      }];
      this.eventListen(events, 'remove', this.table.tr[0]);
    }
    /**
     * 按下调整交换列的事件
     */

  }, {
    key: "getThDome",
    value:
    /**
     * 获取当前th上的对象数据
     * @param {*} e
     * @returns
     * @memberof TableHeader
     */

    /*
    getCurrentEventData(th){
      if(!th){
        console.log(" event target is not th ! ");
        return null;
      }
      let key = th.getAttribute('data-line-key');
      let data = this.props.rows[0].find(da=>da.key == key);
      if(data){
        return data;
      }else{
        console.log(" getCurrentEventData data is null ");
        return null;
      }
    }
    */

    /**
    * 根据当前鼠标点击的节点，进行递归遍历，最终找到th
    * @param {*} element
    * @returns  <th />对象
    * @memberof TableHeader
    */
    function getThDome(element) {
      var _tagName = element.tagName.toLowerCase();

      if (element.getAttribute('data-filter-type') === 'filterContext') return null;
      if (_tagName === 'i') return null;

      if (_tagName != 'th') {
        return this.getThDome(element.parentElement);
      } else {
        return element;
      }
    } //---拖拽列交换----end-----

    /**
     * 过滤输入后或下拉条件的回调函数
     */

  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props6 = this.props,
          clsPrefix = _this$props6.clsPrefix,
          rowStyle = _this$props6.rowStyle,
          draggable = _this$props6.draggable,
          dragborder = _this$props6.dragborder,
          rows = _this$props6.rows,
          filterable = _this$props6.filterable,
          fixed = _this$props6.fixed,
          columnsChildrenList = _this$props6.columnsChildrenList,
          columnManager = _this$props6.columnManager;
      var attr = dragborder ? {
        id: "".concat(prefix, "-table-drag-thead-").concat(this.theadKey)
      } : {};
      var showColumns = columnManager.showLeafColumns(fixed);
      return /*#__PURE__*/React.createElement("thead", _extends({
        className: "".concat(clsPrefix, "-thead")
      }, attr, {
        "data-theader-fixed": "scroll",
        ref: function ref(_thead) {
          return _this5._thead = _thead;
        }
      }), rows.map(function (row, index) {
        var leftFixedColIndex = 0,
            rightFixedColIndex = 0,
            centerColIndex = 0;
        return /*#__PURE__*/React.createElement("tr", {
          key: index,
          style: rowStyle,
          className: filterable && index == rows.length - 1 ? 'filterable' : ''
        }, row.map(function (da, columIndex, arr) {
          da.children = da.required ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
            className: "required"
          }, "*"), da.children) : da.children;
          var thHover = da.drgHover ? " ".concat(clsPrefix, "-thead th-drag-hover") : "";
          delete da.drgHover;
          /*
          let fixedStyle = "";
          //主表格下、固定列或者是过滤行中含有固定列时添加该属性
          if (!fixed && (da.fixed || (filterable && index == rows.length - 1 && rows[0][columIndex].fixed)) ) {
            fixedStyle = ` ${clsPrefix}-row-fixed-columns-in-body`;
          }
          */

          var thClassName = "".concat(da.className) ? "".concat(da.className) : '';

          if (da.titleAlign) {
            thClassName += " text-".concat(da.titleAlign, " ");
          } else if (da.textAlign) {
            thClassName += " text-".concat(da.textAlign, " ");
          }

          delete da.textAlign;
          delete da.titleAlign;
          var colKey = da.key || da.dataIndex || index + '-' + columIndex; //避免key为undefined

          if (filterable && index == rows.length - 1) {
            da.children = _this5.filterRenderType(da["filtertype"], da.dataIndex, columIndex);

            if (da.key === undefined) {
              colKey = colKey + '-filterable';
            }

            delete da.filterdropdownfocus;
          }

          if (draggable) {
            thClassName += " ".concat(clsPrefix, "-thead th-drag ").concat(thHover, " ");
          }

          if (dragborder) {
            thClassName += " ".concat(clsPrefix, "-thead-th ");
          } // if (columnsChildrenList.length-1 == columIndex) {
          //   thClassName += " th-can-not-drag";
          // }
          //thClassName += ` ${fixedStyle}`;
          //存放到dom上的数据


          var domData = {
            'data-th-fixed': da.fixed,
            'data-th-width': da.width,
            'data-line-key': da.key,
            // 'data-line-index':columIndex,//不分区域的列索引
            'data-col-key': colKey,
            'data-col-index': fixed && da.fixed ? da.fixed == 'right' ? rightFixedColIndex : leftFixedColIndex : !fixed && !da.fixed && centerColIndex //左中右各区域的列索引

          }; //渲染拖拽列宽度的抓手

          var dragGapView = null;

          if (dragborder && !da.colSpan) {
            //如果存在colSpan则表明其是组合列（不允许拖拽），不是最终显示列。
            var isLastCol = false; //是否为本区域最后一列

            if (fixed && da.fixed) {
              if (fixed == 'right' && da.fixed == 'right') {
                isLastCol = showColumns.length - 1 == rightFixedColIndex ? 'last' : '';
              }
            } else if (!fixed && !da.fixed) {
              isLastCol = showColumns.length - 1 == centerColIndex;
            }

            dragGapView = /*#__PURE__*/React.createElement("div", _extends({
              ref: function ref(el) {
                return _this5.gap = el;
              },
              "data-type": "online"
            }, domData, {
              className: "".concat(clsPrefix, "-thead-th-drag-gap ").concat(da.fixed, " ").concat(isLastCol ? 'last' : '')
            }), /*#__PURE__*/React.createElement("div", {
              className: "online"
            }));
          }

          var thProps = Object.assign({}, da);

          if (da.maxWidth || da.width) {
            //由于th中文本过长时会撑开内容需要显示声明maxWidth以确保省略文本css样式生效
            thProps.style = thProps.style || {};
            thProps.style.maxWidth = da.maxWidth || da.width;
          }

          delete thProps.width;
          delete thProps.dataIndex; //多余属性不渲染到dom元素上
          //计数+1

          fixed && da.fixed ? da.fixed == 'right' ? rightFixedColIndex++ : leftFixedColIndex++ : !fixed && !da.fixed && centerColIndex++;

          if (!da.fixed && !fixed) {
            //非固定表头 , data-type="draggable"标识允许进行列拖拽排序
            return /*#__PURE__*/React.createElement("th", _extends({}, thProps, {
              key: colKey,
              className: thClassName,
              "data-type": "draggable"
            }, domData, {
              onCopy: function onCopy(event) {
                _this5.onCopy(da, columIndex, event);
              }
            }), da.children, dragGapView);
          } else if (da.fixed && fixed) {
            //固定表头
            if (da.dataIndex == 'checkbox' && da.fixed == 'left') {
              //多选框列
              return /*#__PURE__*/React.createElement("th", thProps, da.children);
            } else if (filterable && index == rows.length - 1) {
              //固定列下的筛选单元格需要一个空占位
              return /*#__PURE__*/React.createElement("th", {
                dangerouslySetInnerHTML: {
                  __html: '&nbsp;'
                }
              });
            } else {
              return /*#__PURE__*/React.createElement("th", _extends({}, thProps, {
                onClick: da.onClick ? da.onClick.bind(_this5, da) : null,
                key: colKey
              }, domData, {
                onCopy: _this5.onCopy
              }), da.children, dragGapView);
            }
          } else {
            if (da.key == "".concat(prefix, "-table-expandIconAsCell")) {
              //展开列
              return /*#__PURE__*/React.createElement("th", thProps, da.children);
            }
          }
        }));
      }));
    }
  }]);

  return TableHeader;
}(Component);

_defineProperty(TableHeader, "defaultProps", {
  tableUid: null,
  columnManager: null,
  draggable: false,
  onDragEnd: null,
  onDrop: null,
  afterDragColWidth: null,
  contentWidthDiff: 0 //中间区域最后一列需要补充的宽度

});

TableHeader.propTypes = propTypes;
export default TableHeader;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/TableHeader.js